import React from 'react';
import { Button } from './ui/Button';
import { Moon, ArrowRight } from 'lucide-react';
import { useCheckoutUrl } from '../hooks/useCheckoutUrl';
export function EmotionalClose() {
  const {
    handleCheckout
  } = useCheckoutUrl();
  return <section className="relative py-20 px-4 md:px-8 bg-navy-900 text-cream-100 overflow-hidden" data-id="element-35">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-navy-900 via-navy-800 to-navy-900" data-id="element-36" />

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-37">
        {/* Emotional Content */}
        <div className="mb-20" data-id="element-38">
          <span className="text-4xl mb-4 block" data-id="element-39">💚</span>
          <h2 className="text-gold-500 font-bold tracking-widest uppercase text-sm mb-6" data-id="element-40">
            SECCIÓN 11 — CIERRE EMOCIONAL
          </h2>

          <h3 className="text-3xl md:text-5xl font-serif font-bold mb-10 text-cream-50" data-id="element-41">
            Lo Que Mereces Recuperar
          </h3>

          <div className="prose prose-lg prose-invert mx-auto font-body text-cream-200 leading-relaxed space-y-6" data-id="element-42">
            <p data-id="element-43">No se trata solo de dormir más horas.</p>
            <p data-id="element-44">Se trata de recuperar a la mujer que eres cuando descansas.</p>
            <p data-id="element-45">
              La que amanece y piensa: "Hoy sí puedo." La que tiene paciencia
              con sus hijos, con sus nietos, consigo misma. La que toma
              decisiones claras, no desde el miedo de la madrugada. La que se
              mira al espejo y se ve — no el agotamiento.
            </p>
            <p data-id="element-46">Esa mujer no desapareció.</p>
            <p data-id="element-47">Está esperando al otro lado de una buena noche de sueño.</p>
          </div>

          <div className="my-12 p-8 border-y-2 border-gold-500/30 bg-navy-800/50 backdrop-blur-sm" data-id="element-48">
            <p className="text-2xl md:text-3xl font-serif italic text-gold-400" data-id="element-49">
              "No se trata de dormir más. Se trata de recuperar la mujer que
              eres cuando descansas."
            </p>
          </div>

          <div className="prose prose-lg prose-invert mx-auto font-body text-cream-200" data-id="element-50">
            <p data-id="element-51">Eres una mujer fuerte que ha cargado mucho.</p>
            <p data-id="element-52">Esta noche, te damos permiso de soltar.</p>
            <p className="text-xl font-bold text-white" data-id="element-53">
              No mañana. Esta noche.
            </p>
          </div>
        </div>

        {/* Final CTA Section */}
        <div className="bg-gradient-to-br from-navy-800 to-navy-900 p-8 md:p-12 rounded-3xl shadow-2xl border border-gold-500/30" data-id="element-54">
          <h3 className="text-2xl font-bold text-gold-400 mb-8 uppercase tracking-widest" data-id="element-55">
            🚀 Tu Plan Para Las Próximas Horas:
          </h3>

          {/* Steps Grid */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-12 text-left" data-id="element-56">
            <div className="bg-navy-900/50 p-4 rounded-lg border border-navy-700" data-id="element-57">
              <span className="text-gold-500 font-bold block mb-1" data-id="element-58">
                1. Ahora mismo
              </span>
              <span className="text-sm text-cream-200" data-id="element-59">
                Descarga la guía. Abre el Template 1.
              </span>
            </div>
            <div className="bg-navy-900/50 p-4 rounded-lg border border-navy-700" data-id="element-60">
              <span className="text-gold-500 font-bold block mb-1" data-id="element-61">
                2. Esta tarde
              </span>
              <span className="text-sm text-cream-200" data-id="element-62">
                Cena ligera. Prepara el Té Abuela.
              </span>
            </div>
            <div className="bg-navy-900/50 p-4 rounded-lg border border-navy-700" data-id="element-63">
              <span className="text-gold-500 font-bold block mb-1" data-id="element-64">
                3. Esta noche
              </span>
              <span className="text-sm text-cream-200" data-id="element-65">
                Ritual completo. Luz off. A dormir.
              </span>
            </div>
            <div className="bg-gold-500/10 p-4 rounded-lg border border-gold-500/50" data-id="element-66">
              <span className="text-gold-400 font-bold block mb-1" data-id="element-67">
                4. En 5 noches
              </span>
              <span className="text-sm text-cream-100 font-bold" data-id="element-68">
                Despiertas descansada, serena y lista.
              </span>
            </div>
          </div>

          <div className="flex flex-col items-center gap-4 mb-10" data-id="element-69">
            <p className="text-cream-200 text-lg" data-id="element-70">
              🌙 De mujer agotada que da vueltas en la cama...
            </p>
            <ArrowRight className="h-6 w-6 text-gold-500 rotate-90 md:rotate-0" data-id="element-71" />
            <p className="text-gold-400 text-xl font-bold font-serif" data-id="element-72">
              A mujer serena con energía para su familia, sus ingresos y su paz.
            </p>
          </div>

          <div className="flex flex-col gap-4 max-w-md mx-auto" data-id="element-73">
            <div id="precio" className="flex flex-col items-center gap-2 mb-2" data-id="element-74">
              <div className="flex items-center gap-3" data-id="element-75">
                <span className="text-cream-200/60 line-through text-xl" data-id="element-76">
                  $550 MXN
                </span>
                <span className="bg-gold-500 text-navy-900 text-sm font-bold px-2 py-1 rounded-md" data-id="element-77">
                  80% OFF
                </span>
              </div>
              <span className="text-gold-400 font-bold text-4xl" data-id="element-78">$110 MXN</span>
            </div>
            <Button className="w-full text-lg py-5 shadow-gold-500/20" onClick={handleCheckout} data-id="element-79">
              SÍ, ME LO MEREZCO. DESCARGAR AHORA
            </Button>
          </div>

          <div className="mt-8 text-sm text-cream-200/60 space-y-2" data-id="element-80">
            <p data-id="element-81">Acceso inmediato. Descarga en segundos. Garantía de 7 noches.</p>
            <div className="flex items-center justify-center gap-2 text-gold-500/80 mt-4" data-id="element-82">
              <Moon className="h-4 w-4" data-id="element-83" />
              <span className="italic" data-id="element-84">
                Tu cama te espera en silencio. Empieza ahora. Tu descanso es
                sagrado.
              </span>
              <Moon className="h-4 w-4" data-id="element-85" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}